import {
  Heading,
  Image,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { useAppDispatch } from "../../redux/hooks";
import { logout } from "../../redux/modules/auth";
import { goToPublicHome, markPublicLogout } from "../../utils/restoreAuthSession";
import { flushAccount } from "../../redux/modules/account";
import { flushKYC } from "../../redux/modules/kyc";
import {
  resetAmountData,
  resetTransaction,
} from "../../redux/modules/transactions";
import RouteLink from "../../components/form-element/RouteLink";
import capitalizeBusinessName from "../../utils/capitalizeBusinessName";
import capitalizeText from "../../utils/capitalizeText";
import profileName from "../../utils/profileName";

interface ProfileBadgeMenuProps {
  userData: any;
}

const ProfileBadgeMenu: React.FC<ProfileBadgeMenuProps> = ({ userData }) => {
  const dispatch = useAppDispatch();

  if (!userData?.firstName && !userData?.imageUrl) {
    return null;
  }

  const logoutUser = () => {
    markPublicLogout();
    dispatch(logout());
    dispatch(flushAccount());
    dispatch(flushKYC());
    dispatch(resetTransaction());
    dispatch(resetAmountData());
    goToPublicHome();
  };

  const displayName = userData.isBusinessProfie
    ? `${profileName(userData.company?.businessName)}`
    : `${profileName(userData.firstName)} ${profileName(userData.lastName)}`;

  return (
    <Menu variant="profile" preventOverflow={true}>
      <MenuButton aria-label="Account menu">
        {userData.imageUrl ? (
          <Image
            src={userData.imageUrl}
            alt=""
            width="40px"
            height="40px"
            objectFit={"cover"}
            borderRadius={"50%"}
          />
        ) : userData.isBusinessProfie ? (
          <Heading
            display="inline-flex"
            as="h5"
            alignItems={"center"}
            justifyContent={"center"}
            size="lg_medium"
            variant="white"
            bg="var(--clr1)"
            py="5px"
            px="6px"
            mr="8px"
            borderRadius="25px"
            cursor="pointer"
            minW="40px"
            minH="40px"
          >
            {capitalizeBusinessName(userData.company?.businessName)}
          </Heading>
        ) : (
          <Heading
            display="inline-flex"
            as="h5"
            alignItems={"center"}
            justifyContent={"center"}
            size="lg_medium"
            variant="white"
            bg="var(--clr1)"
            py="5px"
            px="6px"
            mr="8px"
            borderRadius="25px"
            cursor="pointer"
            minW="40px"
            minH="40px"
          >
            {capitalizeText(userData.firstName)}
            {capitalizeText(userData.lastName)}
          </Heading>
        )}
      </MenuButton>
      <MenuList zIndex={2000}>
        <MenuGroup title={displayName} cursor="default">
          <MenuItem>
            <RouteLink to="/settings?tabIndex=1" text="My Account" />
          </MenuItem>
          <MenuItem onClick={logoutUser}>Log Out</MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  );
};

export default ProfileBadgeMenu;
